import gql from 'graphql-tag'

export const GET_CALENDAR_EVENTS = gql`
  query GetCalendarEvents($studentProfileId: String!) {
    getCalendarEvents(studentProfileId: $studentProfileId) {
      StudentCalendarEventInfo {
        StudentRecordId
        StudentContactEmail
        SessionScheduleInfos {
          Timezone
          Status
          StartTime
          SessionRescheduleDatetime
          SessionLengthInMinutes
          RecordId
          ProgramStatus
          ProgramStartDate
          ProgramName
          ProgramLanguage
          ProgramDeliveryCenter
          EndTime
          CreatedDate
        }
        LastCalendarExport
        LastCalendarEventUpdate
        EventAttendeeInfos {
          Timezone
          Starttime
          RecordId
          ProgramName
          EventType
          EventName
          Endtime
          DurationInHours
          CreatedDate
          CancelledDate
          AttendeeStatus
        }
      }
    }
  }
`
